/******/ (() => {
  const targetSectionId =
    'shopify-section-template--28361282290031__1648166558c4f10501';

  window.PXUTheme.jsFeaturedPromos = {
    init: function ($section) {
      const $slider = $section.find('[data-featured-promotions-slider]');
      if (!$slider.length) return;

      // Clean up before reinitializing in the theme editor.
      const previousCleanup = $slider.data('promoLayoutCleanup');
      if (previousCleanup) previousCleanup();

      const $prev = $section.find('.featured-promotions__nav--prev');
      const $next = $section.find('.featured-promotions__nav--next');
      const $nav = $section.find('.featured-promotions__nav-wrapper');

      const isTarget =
        $slider.closest('#' + targetSectionId).length > 0;

      const desktop = window.matchMedia('(min-width: 768px)');

      let currentMode = null;
      let restoreGrid = null;

      function set(element, property, value) {
        element.style.setProperty(property, value, 'important');
      }

      function startCarousel() {
        if ($slider.data('flickity')) return;

        $slider.flickity({
          initialIndex: 0,
          cellAlign: 'left',
          contain: true,
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false,
          imagesLoaded: true,
          draggable: true
        });
      }

      function stopCarousel() {
        if ($slider.data('flickity')) {
          $slider.flickity('destroy');
        }
      }

      function startGrid() {
        const $tiles =
          $slider.children('.featured-promotions__block');

        // Preserve inline styles so mobile can return to normal.
        const elements = [
          $slider[0],
          ...$tiles.toArray(),
          ...$tiles.find(
            '.featured-promotions__content, ' +
            '.featured-promotions__overlay, ' +
            '.image-element__wrap, img'
          ).toArray(),
          ...$nav.toArray()
        ];

        const originalStyles = elements.map(function (element) {
          return [element, element.getAttribute('style')];
        });

        set($slider[0], 'display', 'grid');
        set(
          $slider[0],
          'grid-template-columns',
          'repeat(5, minmax(0, 1fr))'
        );
        set($slider[0], 'gap', '20px');
        set($slider[0], 'height', 'auto');

        $tiles.each(function (index) {
          set(this, 'display', index < 5 ? 'block' : 'none');
          set(this, 'position', 'relative');
          set(this, 'left', 'auto');
          set(this, 'top', 'auto');
          set(this, 'width', '100%');
          set(this, 'height', 'auto');
          set(this, 'min-width', '0');
          set(this, 'min-height', '0');
          set(this, 'max-width', 'none');
          set(this, 'margin', '0');
          set(this, 'padding', '0');
          set(this, 'float', 'none');
          set(this, 'transform', 'none');
          set(this, 'aspect-ratio', '1 / 1');
          set(this, 'overflow', 'hidden');

          const content =
            this.querySelector('.featured-promotions__content');

          const overlay =
            this.querySelector('.featured-promotions__overlay');

          if (content) {
            set(content, 'position', 'absolute');
            set(content, 'inset', '0');
            set(content, 'width', '100%');
            set(content, 'height', '100%');
            set(content, 'min-height', '0');
          }

          this.querySelectorAll('.image-element__wrap')
            .forEach(function (wrap) {
              set(wrap, 'height', '100%');
            });

          this.querySelectorAll('img').forEach(function (image) {
            set(image, 'width', '100%');
            set(image, 'height', '100%');
            set(image, 'object-fit', 'cover');
          });

          if (overlay) {
            set(overlay, 'display', 'flex');
            set(overlay, 'align-items', 'center');
            set(overlay, 'justify-content', 'center');
            set(overlay, 'text-align', 'center');
          }
        });

        $nav.each(function () {
          set(this, 'display', 'none');
        });

        restoreGrid = function () {
          originalStyles.forEach(function (entry) {
            const element = entry[0];
            const originalStyle = entry[1];

            if (originalStyle === null) {
              element.removeAttribute('style');
            } else {
              element.setAttribute('style', originalStyle);
            }
          });

          restoreGrid = null;
        };
      }

      function updateLayout() {
        const nextMode =
          isTarget && desktop.matches ? 'grid' : 'carousel';

        if (nextMode === currentMode) return;

        if (restoreGrid) restoreGrid();
        stopCarousel();

        if (nextMode === 'grid') {
          startGrid();
        } else {
          startCarousel();
        }

        currentMode = nextMode;
      }

      $prev
        .off('click.promoLayout')
        .on('click.promoLayout', function () {
          if ($slider.data('flickity')) {
            $slider.flickity('previous');
          }
        });

      $next
        .off('click.promoLayout')
        .on('click.promoLayout', function () {
          if ($slider.data('flickity')) {
            $slider.flickity('next');
          }
        });

      desktop.addEventListener('change', updateLayout);

      $slider.data('promoLayoutCleanup', function () {
        desktop.removeEventListener('change', updateLayout);
        $prev.off('.promoLayout');
        $next.off('.promoLayout');

        if (restoreGrid) restoreGrid();
        stopCarousel();

        $slider.removeData('promoLayoutCleanup');
      });

      updateLayout();
    },

    blockSelect: function ($section, blockId) {
      const $slider =
        $section.find('[data-featured-promotions-slider]');

      // Grid mode does not have an active Flickity instance.
      if (!$slider.data('flickity')) return;

      const slideIndex =
        $('#shopify-section-' + blockId).data('promo-index');

      if (slideIndex !== undefined) {
        $slider.flickity('select', slideIndex, true, true);
      }
    },

    unload: function ($section) {
      $section.find('[data-featured-promotions-slider]')
        .each(function () {
          const cleanup = $(this).data('promoLayoutCleanup');

          if (cleanup) {
            cleanup();
          } else if ($(this).data('flickity')) {
            $(this).flickity('destroy');
          }
        });
    }
  };
})()
;